import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { forkJoin } from 'rxjs';
import { AlertMessage } from 'src/app/template/models/alert-message.model';
import { EnrollmentNew } from 'src/app/modules/enrollments/models/enrollment-new.model';
import { Discount } from 'src/app/modules/discounts/models/discount.model';
import { DiscountService } from 'src/app/modules/discounts/services/discount.service';

@Component({
    selector: 'app-enrollment-edit-step-discounts',
    templateUrl: './enrollment-edit-step-discounts.component.html',
    styleUrls: ['./enrollment-edit-step-discounts.component.scss']
})
export class EnrollmentEditStepDiscountsComponent implements OnInit {

    @Input() enrollment: EnrollmentNew;

    @Output() enrollmentChange = new EventEmitter<EnrollmentNew>();
    @Output() isCompleteStep   = new EventEmitter<boolean>();

    public labels: any = {

        discountSelectorLabel : 'Seleccione los descuentos que desee aplicar',
        discountMaxAlertLabel : 'El descuento máximo aplicable es:',
        discountDocsAlertLabel: 'Recuerde que en algunos casos será necesario que aporte documentación acreditativa.'

    }

    public isLoadingData : boolean = true;
    public loadingMessage: AlertMessage = new AlertMessage();
    public loadingErrorMessage: string  = 'Se ha producido un error al cargar la página.';

    public discounts: Discount[];
    public maxDiscount: number;

    constructor(private discountService: DiscountService) { }

    ngOnInit (): void {

        this.initData();
        this.onEnrollmentChange();

    }

    private initData() {

        forkJoin({

            discountsRequest: this.discountService.getByEdition(this.enrollment.edition.editionId)

        }).subscribe({

            next: (requests: any) => {

                this.discounts = requests.discountsRequest;

                let maxDiscountResource = this.enrollment.edition.resources.find((er: any) => er.resourceId === 'max-discount');
                this.maxDiscount = maxDiscountResource ? +maxDiscountResource.value : 0;

            },

            error: (error: any) => {

                this.loadingMessage.showDangerAlert(this.loadingErrorMessage);

            }

        }).add(() => {
            this.isLoadingData = false;
        });

    }

    public isFormValid() {

        return true;

    }

    public onEnrollmentChange() {

        this.isCompleteStep.emit(this.isFormValid());
        this.enrollmentChange.emit(this.enrollment);

    }

}
